import { gqlTagRest } from '@atlassian/jira-common-graphql-tags/src/index.tsx';

export const gqlTagSwag = gqlTagRest;
